import cloneDeep from 'lodash/cloneDeep';
import forEach from 'lodash/forEach';
import DepsService from 'services/dependencies';
import { initGrid } from 'utils/grid/grid';
import { setDirtyForm } from 'app/actions/dirty-forms.actions';
import { fetchInquiryContacts, updateInquiryContact } from 'contact/actions/contact.actions';
import inquiryContactsListTemplate from './inquiry-contacts-list.html';

const DIRTY_FORM = 'inquiryContacts';

const mapStateToThis = ({ session, contact }) => {
  const { locale } = session;
  const { inquiry, inquiryLoadingStatus: isLoading } = contact;
  const { items } = inquiry;

  return {
    locale,
    items,
    isLoading,
  };
};

const mapDispatchToThis = {
  setDirtyForm,
  fetchInquiryContacts,
  updateInquiryContact,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', 'gettextCatalog', '$state', 'Notifications')
class InquiryContactsListController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
    this.DIRTY_FORM = DIRTY_FORM;
  }

  async $onInit() {
    this.headers = this.getHeaders();
    this.defaultParams = {
      [DepsService.config.sortColumnKey]: 'id',
      [DepsService.config.directionKey]: 'asc',
    };
    this.gridModel = initGrid(this.fetchInquiryContacts, this.defaultParams);
    await this.search();
  }

  $onDestroy() {
    this.unsubscribe();
  }

  async search() {
    await this.gridModel.applyFilters();
    this.copyItems();
    this.setEntries(this.locale);
  }

  copyItems() {
    this.itemsCopy = cloneDeep(this.items);
  }

  setEntries(locale) {
    this.language = locale;
    const key = Object.keys(this.items).find((localeKey) => localeKey === locale);
    if (!key) {
      this.items[locale] = {};
    }
  }

  getHeaders() {
    return [
      {
        text: this.gettextCatalog.getString('Inquiry Reason'),
      },
      {
        text: this.gettextCatalog.getString('Inquiry Contact'),
      },
    ];
  }

  onSubmitInquiryContacts() {
    if (this.form.$invalid) return;

    this.ensureAvailabilityIsSameForAllLanguages();
    this.setDirtyForm(this.DIRTY_FORM, false);
    this.form.$setPristine();

    this.updateInquiryContact()
      .then(() => this.Notifications.alertSuccess(this.gettextCatalog.getString('Changes have been saved')))
      .then(() => this.search());
  }

  onCancel() {
    this.setDirtyForm(this.DIRTY_FORM, false);
    this.items = cloneDeep(this.itemsCopy);
  }

  onAvailabilityChange(inquiryContactData) {
    this.applyAvailabilityToOtherLanguages(inquiryContactData);
  }

  applyAvailabilityToOtherLanguages(inquiryContactData) {
    forEach(this.items, (itemsForLanguage, language) => {
      if (language === this.language || !itemsForLanguage) return;
      const item = itemsForLanguage.find((i) => i.keyVal === inquiryContactData.keyVal);
      if (!item) return;
      item.contactEmail = inquiryContactData.contactEmail;
      item.availableForAnonymous = inquiryContactData.availableForAnonymous;
      item.availableForUser = inquiryContactData.availableForUser;
    });
  }

  ensureAvailabilityIsSameForAllLanguages() {
    this.items[this.language].forEach((item) => this.applyAvailabilityToOtherLanguages(item));
  }
}

export default class InquiryContactsListComponent {
  constructor() {
    this.template = inquiryContactsListTemplate;
    this.controller = InquiryContactsListController;
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/contact/components/inquiry-contacts-list/inquiry-contacts-list-component.js